import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=32362e61&scoped=true"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"
import style0 from "./Role.vue?vue&type=style&index=0&id=32362e61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32362e61",
  null
  
)

export default component.exports